module.exports = __webpack_public_path__ + "img/collection-memoireRingsRingsets.e3bc65e.webp";